/**
 * Transcriptions are implemented in two react components: TranscriptionLine, and TranscriptionArrow.
 * This file contains constants used by both of those views
 */

export const TRANSCRIPTION_COLOR = '#FCB768';
export const REVERSE_COMPLEMENT_TRANSCRIPTION_LINE_Y_POSITION = 7;
export const FORWARD_TRANSCRIPTION_LINE_Y_POSITION = 5;
